import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { I18nService } from './i18n.service';

@NgModule({
  imports: [CommonModule, MatNativeDateModule, MatMenuModule],
  exports: [],
  providers: [I18nService],
})
export class I18nModule {}
